import { API_BASE_URL, handleResponse } from './client';

export async function registerUser({ name, email, password, institution,department, country }) {
  const res = await fetch(`${API_BASE_URL}/auth/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, email, password, institution,department, country }),
  });
  return handleResponse(res);
}

export async function loginUser({ email, password }) {
  const res = await fetch(`${API_BASE_URL}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });
  return handleResponse(res);
}

export async function forgotPassword({ email }) {
  const res = await fetch(`${API_BASE_URL}/auth/forgot-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });
  return handleResponse(res);
}

export async function resetPassword({ token, password }) {
  const res = await fetch(`${API_BASE_URL}/auth/reset-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, password }),
  });
  return handleResponse(res);
}

// Auth persists across browser restarts (localStorage), unlike the per-run
// jobId in sessionStorage used by Analysis/Results.
export function saveAuthSession({ token, user }) {
  localStorage.setItem('cry_auth_token', token);
  localStorage.setItem('cry_auth_user', JSON.stringify(user));
}

export function getAuthToken() {
  return localStorage.getItem('cry_auth_token');
}

export function getAuthUser() {
  const raw = localStorage.getItem('cry_auth_user');
  return raw ? JSON.parse(raw) : null;
}

export function clearAuthSession() {
  localStorage.removeItem('cry_auth_token');
  localStorage.removeItem('cry_auth_user');
}

export function isAuthenticated() {
  return Boolean(getAuthToken());
}